import c, { useSWRConfig as u } from "swr";
import f from "swr/mutation";
function m(r = { httpClient: null }) {
  const { cache: t, mutate: n } = u();
  return {
    cache: t,
    empty: async () => {
      for (const e of t)
        await n(e[0]);
    },
    revalidate: async (e) => {
      var a;
      if (!e)
        throw Error('"query" parameter is empty.');
      const { base_url: i } = r.httpClient.createUrl(e);
      for (const o of t)
        ((a = o[0]) == null ? void 0 : a.indexOf(i)) !== -1 && await n(o[0]);
    }
  };
}
function C(r, t = { httpClient: null, params: {} }) {
  if (!t.httpClient)
    throw new Error('Options variable "httpClient" is missing or empty');
  const n = async function(e, i) {
    let a = null;
    return i != null && i.arg ? a = i.arg : e.body && (a = e.body), await t.httpClient.fetch({ ...e, body: a });
  }, { method: l, url: s } = t.httpClient.createUrl(r, t.params);
  return f(
    {
      method: l,
      url: s
    },
    n,
    {
      errorRetryCount: 1,
      revalidateOnFocus: !1,
      suspense: !0
    }
  );
}
const h = typeof window > "u";
function y(r, t = { body: null, httpClient: null, params: {} }) {
  if (!t.httpClient)
    throw new Error('Options variable "httpClient" is missing or empty');
  const { method: n, url: l } = t.httpClient.createUrl(r, t.params);
  return c(
    {
      body: t.body,
      method: n,
      url: l
    },
    r ? t.httpClient.fetch.bind(t.httpClient) : new Promise(() => {
    }),
    {
      errorRetryCount: 1,
      fallbackData: h ? null : void 0,
      revalidateOnFocus: !1,
      suspense: !0
    }
  );
}
export {
  m as useCache,
  C as useMutate,
  y as useRequest
};
//# sourceMappingURL=swr.es.js.map
